import { useApiClient } from "@lib/utils/hooks/useApiClient";
import {
  FacilityDetailsResponse,
  FacilitySummaryResponse,
  MapFilters,
  SearchParams,
} from "@repo/shared-types";
import { useEffect, useState } from "react";

import { useMapSectionCachedPaths } from "./useMapSectionCachedPaths";
import { useMapSectionQuery } from "./useMapSectionQuery";

export function useMapSectionData() {
  const query = useMapSectionQuery();
  const apiClient = useApiClient();
  const [filters, setFilters] = useState<MapFilters>({ ids: [], entries: [] });
  const { paths, setPaths, searchPaths } = useMapSectionCachedPaths();
  const [facilities, setFacilities] = useState<FacilitySummaryResponse[]>([]);
  const [poi, setPoi] = useState<FacilityDetailsResponse | null>(null);
  const serializedQuery = JSON.stringify(query);

  useEffect(() => {
    async function loadMapData(searchParams: SearchParams) {
      const promises = [
        apiClient.getMapFilters(
          searchParams.type ? { type: searchParams.type } : {}
        ),
        searchPaths(searchParams),
        apiClient.searchFacilities(searchParams),
        searchParams.poi
          ? apiClient.searchFacility(searchParams.poi as string)
          : null,
      ] as const;

      const mapData = await Promise.all(promises);

      setFilters(mapData[0]);
      setPaths(mapData[1]);
      setFacilities(mapData[2]);
      setPoi(mapData[3]);
    }

    loadMapData(query);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serializedQuery]);

  return { filters, paths, facilities, poi };
}
